<template>
  <div>
    <b-container fluid class="d-flex align-items-center back-wrapper">
          <b-row class="full-width">
            <b-col lg="7" md="10">
              <router-link :to="{name: 'todasOrdenesStatus'}" class="back-item">
                  <img class="arrow-back" src="img/theme/icn_arrowback.svg" alt="">
                  <span>TODOS LOS ESTATUS</span>
              </router-link>
            </b-col>
          </b-row>
        </b-container>
    <div class="header pb-8 pt-5 pt-lg-6 d-flex align-items-center profile-header">
      <b-container fluid>
        <!-- Mask -->
        <span class="mask"></span>
        <!-- Header container -->
        <h1 class="text-center">Panel de Configuración</h1>
      </b-container>
    </div>

    <b-container fluid class="mt--6 edit-order-status-wrapper">
      <b-row>
        <b-col xl="12" class="order-xl-1">
          <card>
            <b-row align-v="center" slot="header" >
              <b-col cols="8">
                <h3 class="mb-0">{{ hospital }}</h3>
              </b-col>
            </b-row>

            <b-form @submit.prevent="updateProfile">
              <base-alert v-if="success === true" type="success" icon="ni ni-like-2 ni-lg" dismissible>
                <strong>¡Bien hecho!</strong> La información de la orden se actualizó exitosamente.
              </base-alert>
              <base-alert v-if="success === false" type="danger" icon="ni ni-like-2 ni-lg" dismissible>
                <strong>¡Error!</strong> {{error}}
              </base-alert>
              <h6 class="heading-small text-muted mb-4">DETALLES DEL PEDIDO</h6>


              <div class="pl-lg-4">
                <b-row>
                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="No. de Orden"
                      placeholder="order"
                      v-model="$route.params.orderId"
                      name="order"
                      disabled
                      required
                    >
                    </base-input>
                  </b-col>

                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="Nombre de usuario"
                      placeholder="Nombre"
                      disabled
                      v-model="name"
                      name="name"
                      required
                    >
                    </base-input>
                  </b-col>

                  <b-col lg="4">
                    <label class="form-control-label" for="">Estatus del pedido</label>
                    <multiselect
                      :show-labels="false"
                      v-model="status"
                      :options="['Solicitud', 'Producción', 'Proceso de importación', 'Almacen Domik', 'Bordado', 'Pick & Pack', 'Calidad', 'En tránsito a destino', 'Pendientes de entrega', 'Entregado', 'Rechazado']"
                      placeholder='Selecciona el estado'
                      name="status"
                      required
                      >
                    </multiselect>
                  </b-col>

                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="Fecha del pedido"
                      placeholder="order"
                      v-model="date"
                      name="order"
                      disabled
                      required
                    >
                    </base-input>
                  </b-col>

                  <b-col lg="4">
                    <base-input
                      type="text"
                      v-if="this.status == 'Entregado'"
                      label="Cantidad de entrega parcial"
                      placeholder=""
                      v-model="partial"
                      name="partial"
                    >
                    </base-input>
                  </b-col>

                </b-row>
                <hr class="my-4">
                <h6 class="heading-small text-muted mb-4">Filipina</h6>
                <b-row >
                  <b-col lg="4" class="mb-4">
                    <label class="form-control-label" for="">Modelo</label>
                    <multiselect
                      :show-labels="false"
                      v-model="scrubModel"
                      :options="modelsColor"
                      disabled
                      placeholder='Selecciona el modelo'>
                    </multiselect>
                  </b-col>
                  <b-col lg="4" class="mb-4">
                    <label class="form-control-label" for="">Color</label>
                    <multiselect
                      :show-labels="false"
                      v-model="scrubColor"
                      :options="modelsColor"
                      disabled
                      placeholder='Selecciona el color del modelo'>
                    </multiselect>
                  </b-col>
                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="Cantidad"
                      placeholder="Cantidad"
                      v-model="scrubQty"
                      disabled
                      name="jacketQty"
                      required
                    >
                    </base-input>
                  </b-col>
                </b-row>


                <hr class="my-4">
                <h6 class="heading-small text-muted mb-4">Pantalón</h6>
                <b-row >
                  <b-col lg="4" class="mb-4">
                    <label class="form-control-label" for="">Modelo</label>
                    <multiselect
                      :show-labels="false"
                      v-model="pantsModel"
                      :options="modelsColor"
                      disabled
                      placeholder='Selecciona el modelo'>
                    </multiselect>
                  </b-col>
                  <b-col lg="4" class="mb-4">
                    <label class="form-control-label" for="">Color</label>
                    <multiselect
                      :show-labels="false"
                      v-model="pantsColor"
                      :options="modelsColor"
                      disabled
                      placeholder='Selecciona el color del modelo'>
                    </multiselect>
                  </b-col>
                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="Cantidad"
                      placeholder="Cantidad"
                      disabled
                      v-model="pantsQty"
                      name="jacketQty"
                      required
                    >
                    </base-input>
                  </b-col>
                </b-row>

                <hr class="my-4">
                <h6 class="heading-small text-muted mb-4">Chamarra</h6>
                <b-row >
                  <b-col lg="4" class="mb-4">
                    <label class="form-control-label" for="">Modelo</label>
                    <multiselect
                      :show-labels="false"
                      v-model="jacketModel"
                      :options="modelsColor"
                      disabled
                      placeholder='Selecciona el modelo'>
                    </multiselect>
                  </b-col>
                  <b-col lg="4" class="mb-4">
                    <label class="form-control-label" for="">Color</label>
                    <multiselect
                      :show-labels="false"
                      v-model="jacketColor"
                      :options="modelsColor"
                      disabled
                      placeholder='Selecciona el color del modelo'>
                    </multiselect>
                  </b-col>
                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="Cantidad"
                      placeholder="Cantidad"
                      v-model="jacketQty"
                      disabled
                      name="jacketQty"
                      required
                    >
                    </base-input>
                  </b-col>
                </b-row>


                <hr class="my-4">
                <h6 class="heading-small text-muted mb-4">Bata</h6>
                <b-row >
                  <b-col lg="4" class="mb-4">
                    <label class="form-control-label" for="">Modelo</label>
                    <multiselect
                      :show-labels="false"
                      v-model="coatModel"
                      :options="modelsColor"
                      disabled
                      placeholder='Selecciona el modelo'>
                    </multiselect>
                  </b-col>
                  <b-col lg="4" class="mb-4">
                    <label class="form-control-label" for="">Color</label>
                    <multiselect
                      :show-labels="false"
                      v-model="coatColor"
                      :options="modelsColor"
                      disabled
                      placeholder='Selecciona el color del modelo'>
                    </multiselect>
                  </b-col>
                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="Cantidad"
                      placeholder="Cantidad"
                      v-model="jacketQty"
                      name="jacketQty"
                      disabled
                      required
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </div>
              <hr class="my-4">
              <b-button type="submit" variant="primary" class="mt-4">Guardar</b-button>
            </b-form>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import axios from 'axios'
import qs from 'qs'

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      name: '',
      firstLastname: '',
      secondLastname: '',
      hospital: '',
      status: '',
      partial: '',
      date: '',
      scrubQty: '',
      scrubModel: '',
      scrubSize: '',
      scrubColor: '',
      scrubLogoImage: '',
      scrubLogo: '',
      scrubEmbroid: '',
      embroidScrubPosition: '',
      embroidScrubFont: '',
      embroidScrubFontColor: '',
      pantsQty: '',
      pantsModel: '',
      pantsSize: '',
      pantsColor: '',
      pantsLogo: '',
      pantsLogoImage: '',
      pantsEmbroid: '',
      embroidPantsPosition: '',
      embroidPantsFont: '',
      embroidPantsFontColor: '',
      coatQty: '',
      coatModel: '',
      coatSize: '',
      coatColor: '',
      coatLogo: '',
      coatLogoImage: '',
      coatEmbroid: '',
      embroidCoatPosition: '',
      embroidCoatFont: '',
      embroidCoatFontColor: '',
      jacketQty: '',
      jacketModel: '',
      jacketSize: '',
      jacketColor: '',
      jacketLogo: '',
      jacketLogoImage: '',
      jacketEmbroid: '',
      embroidJacketPosition: '',
      embroidJacketFont: '',
      embroidJacketFontColor: '',
      hospitals: [],
      colors: [],
      brands: [],
      genders: [],
      success: '',
      error: '',
      modelsColor: []
    }
  },
  methods: {
    updateProfile() {
      this.token = localStorage.getItem('token')
      this.user = localStorage.getItem('id_user')
      axios
      .post(
        process.env.VUE_APP_ROUTE_BACKEND_API+'orders_api.php',
        qs.stringify({
          api_token: this.token,
          user_id: this.user,
          option: 'edit_order_status',
          order_id: this.$route.params.orderId,
          order_status: this.status,
          order_partial: this.partial
        }),
      )
      .then((response) => {
        if (!response.data.error.code) {
          this.success = true
        } else {
          this.success = false
          this.error = response.data.error.description
        }
      })
      .catch((err) => {
        console.log(err)
      })
    }
  },
  async created() {
    this.token = localStorage.getItem('token')
    this.user = localStorage.getItem('id_user')
    await axios
    .post(
      process.env.VUE_APP_ROUTE_BACKEND_API+'orders_api.php',
      qs.stringify({
        api_token: this.token,
        user_id: this.user,
        option: 'get_order',
        order_id: this.$route.params.orderId
      }),
    )
    .then((response) => {
      if (!response.data.error.code) {
        this.name = response.data.order.name
        this.firstLastname = response.data.order.first_lastname
        this.secondLastname = response.data.order.second_lastname
        this.hospital = response.data.order.hospital
        this.status = response.data.order.status
        this.partial = response.data.order.partial
        this.date = response.data.order.date
        this.scrubQty = response.data.order.scrub_qty
        this.scrubModel = response.data.order.scrub_model
        this.scrubSize = response.data.order.scrub_size
        this.scrubColor = response.data.order.scrub_color
        this.scrubLogoImage = response.data.order.scrub_logo_image
        this.scrubLogo = response.data.order.scrub_logo
        this.scrubEmbroid = response.data.order.embroid_scrub
        this.embroidScrubPosition = response.data.order.embroid_scrub_position
        this.embroidScrubFont = response.data.order.embroid_scrub_font
        this.embroidScrubFontColor = response.data.order.embroid_scrub_font_color
        this.pantsQty = response.data.order.pants_qty
        this.pantsModel = response.data.order.pants_model
        this.pantsSize = response.data.order.pants_size
        this.pantsColor = response.data.order.pants_color
        this.pantsLogo = response.data.order.pants_logo
        this.pantsLogoImage = response.data.order.pants_logo_image
        this.pantsEmbroid = response.data.order.embroid_pants
        this.embroidPantsPosition = response.data.order.embroid_pants_position
        this.embroidPantsFont = response.data.order.embroid_pants_font
        this.embroidPantsFontColor = response.data.order.embroid_pants_font_color
        this.coatQty = response.data.order.coat_qty
        this.coatModel = response.data.order.coat_model
        this.coatSize = response.data.order.coat_size
        this.coatColor = response.data.order.coat_color
        this.coatLogo = response.data.order.coat_logo
        this.coatLogoImage = response.data.order.coat_logo_image
        this.coatEmbroid = response.data.order.embroid_coat
        this.embroidCoatPosition = response.data.order.embroid_coat_position
        this.embroidCoatFont = response.data.order.embroid_coat_font
        this.embroidCoatFontColor = response.data.order.embroid_coat_font_color
        this.jacketQty = response.data.order.jacket_qty
        this.jacketModel = response.data.order.jacket_model
        this.jacketSize = response.data.order.jacket_size
        this.jacketColor = response.data.order.jacket_color
        this.jacketLogo = response.data.order.jacket_logo
        this.jacketLogoImage = response.data.order.jacket_logo_image
        this.jacketEmbroid = response.data.order.embroid_jacket
        this.embroidJacketPosition = response.data.order.embroid_jacket_position
        this.embroidJacketFont = response.data.order.embroid_jacket_font
        this.embroidJacketFontColor = response.data.order.embroid_jacket_font_color
        }
    })
    .catch((err) => {
      console.log(err)
    })
    await axios
      .post(
        process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
        qs.stringify({ api_token: this.token, user_id: this.user, option: 'get_catalogs'}),
      )
      .then((response) => {
        if (!response.data.error.code && response.data.hospitals) {
          let temp = []
          Object.keys(response.data.hospitals).map((key) => [response.data.hospitals[key]]).map(function(value) {
              temp.push(value[0])
          })
          this.hospitals = temp
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }
};
</script>
<style scope>
.full-width{
  width: 100% !important;
}
.edit-order-status-wrapper .form-control:disabled,
.edit-order-status-wrapper .form-control[readonly] {
    background-color: transparent;
    border: 1px solid #11235721;
    opacity: 1;
}
.edit-order-status-wrapper .multiselect__tags{
    border: 1px solid #11235721 !important;
}
.edit-order-status-wrapper .multiselect--disabled .multiselect__select{
  background: transparent;
}
.edit-order-status-wrapper .multiselect--disabled,
.edit-order-status-wrapper .multiselect__single{
  color: #112357 !important;
  opacity: 1 !important;
}
</style>
